import constant from 'lodash/constant';
export const _constant = constant;
